import { hasAccess } from 'cp-client-auth!sofe';
import { checkPermissions } from '../primary-navbar';

export const permissionChecks = {
  isClient(user) {
    return hasAccess(user)('client');
  },
  canCreateTask(user) {
    return hasAccess(user)(['tasks_generic']) && hasAccess(user)(['tasks_create_edit']);
  },
  canCreateNotice(user) {
    return hasAccess(user, true)(['tasks_notices', 'tasks_create_edit']);
  },
  canCreateEvent(user) {
    return hasAccess(user)('communications')
  },
  canCreateTaxReturn(user) {
    return hasAccess(user)(['tasks_organizers']) && hasAccess(user)(['tasks_create_edit']);
  },
  canCreateInvoice(user) {
    return hasAccess(user)(['billing_invoices_create_edit']);
  },
  canCreatePayment(user) {
    return hasAccess(user)(['billing_payments_create_edit']);
  },
  canCreateTranscript(user) {
    return hasAccess(user)(['transcripts']);
  },
  canCreateUser(user) {
    return hasAccess(user)(['contacts_create_edit']);
  },
  transcriptsOnly(user) {
    return checkPermissions(user, 'transcripts-only');
  },
  canCreateClientRequest(user) {
    return hasAccess(user)(['tasks_client_requests']) && hasAccess(user)(['tasks_create_edit']);
  },
  canAccessContactFiles(user) {
    return hasAccess(user)('files_contact');
  },
  canManageClientPortals(user) {
    return hasAccess(user)('contacts_manage_client_portals');
  },
  canAccessInternalFiles(user) {
    return hasAccess(user)('files_internal');
  },
  canAccessTime(user) {
    return hasAccess(user)('time_tracking');
  },
};

export function parseClientIdInHash(hash) {
  let myRegex = /clients?\/(\d*)/g;
  let match = myRegex.exec(hash);
  return match && Number(match[1]) ? Number(match[1]) : null;
}

export const getTaskIdFromUrl = hash => {
  const matches = /task?\/([A-Z0-9]+)/.exec(hash);
  return matches ? matches[1] : null;
};

export const getSubtaskIdFromUrl = hash => {
  const matches = /subtask=?([A-Z0-9]+)/.exec(hash);
  return matches ? matches[1] : null;
};
